import OptModal from './OtpModal'

export default OptModal
